import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

export const AuthenticatedRoute = ({ children }) => {
  const location = useLocation();
  const isLoggedIn = useSelector((state) => state?.account?.isLoggedIn);

  if (!isLoggedIn) {
    return <Navigate to="/account/login" state={{ from: location }} replace />;
  }

  return children;
};

export default AuthenticatedRoute;
